import { PettyCashUpdatePage } from '@/features/petty-cash/pages/PettyCashUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/petty-cash/refund/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["petty_cash.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: () => <PettyCashUpdatePage type="refund" />,
})
